import { render, staticRenderFns } from "./recordsDetail.vue?vue&type=template&id=7dcc9bc9"
import script from "./recordsDetail.vue?vue&type=script&lang=js"
export * from "./recordsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports